import React from "react";

export interface ReportTabItem {
  id: string;
  label: string;
}

interface ReportTabsProps {
  tabs: ReportTabItem[];
  activeTabId: string;
  onSelect: (tabId: string) => void;
  /** When true, tabs sit in a row with other controls (no full-width wrapper, no border). Parent provides the row border. */
  inline?: boolean;
  /**
   * When inline, horizontal scroll strip uses full width (e.g. tabs on a row below date/export).
   * When false (default), strip uses flex-1 to share a row with sibling controls (e.g. Employees report).
   */
  inlineFullWidth?: boolean;
}

export function ReportTabs({ tabs, activeTabId, onSelect, inline, inlineFullWidth }: ReportTabsProps) {
  const tabButtons = tabs.map((tab) => {
    const isActive = activeTabId === tab.id;
    return (
      <button
        key={tab.id}
        type="button"
        onClick={() => onSelect(tab.id)}
        className={`h-12 flex shrink-0 items-center cursor-pointer relative transition-colors ${
          isActive
            ? "text-[#FD7657] border-b-2 border-[#FD7657] -mb-px font-semibold"
            : "text-[#6b7280] border-b-0 hover:text-[#374151] font-normal"
        }`}
      >
        <span className="text-sm">{tab.label}</span>
      </button>
    );
  });

  if (inline) {
    const stripWidth = inlineFullWidth ? "w-full" : "flex-1";
    return (
      <div
        className={`min-w-0 ${stripWidth} overflow-x-auto overscroll-x-contain`}
        style={{ scrollbarWidth: "thin", scrollbarColor: "#D1D1D1 #F1F1F2" }}
      >
        <div className="flex flex-nowrap items-center gap-x-6">{tabButtons}</div>
      </div>
    );
  }
  return (
    <div className="w-full border-b border-[#e5e7eb] mb-4">
      <div className="flex gap-x-6 items-center">{tabButtons}</div>
    </div>
  );
}
